import React, { useState, useEffect } from "react";
import {
  Typography,
  Modal,
  Box,
  ImageListItem,
  Divider,
  Button,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import Close from "../../../assets/icons/Close.svg";
import GreyDownArrow from "../../../assets/icons/GreyDownArrow.svg";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  setIsOpenModelAddSendNotificationMaster,
  addSendNotificationMasterList,
} from "../../../redux/actions/mastersAction";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "1px solid #FFFFFF",
  boxShadow: 24,
  padding: "20px 0px 20px 0px",
  borderRadius: "12px",
  outline: "none",
};

const AddNotificationBroadcastModel = () => {
  const dispatch = useDispatch();
  const [vesselName, setVesselName] = useState("");
  const CompanyID = localStorage.getItem("companyID");

  const SendNotificationModel = useSelector(
    (state) => state?.masters?.models?.AddSendNotificationModel
  );
  const isSaveButtonLoading = useSelector(
    (state) => state?.user?.isSaveButtonLoading
  );

  const vesselMasterData = useSelector(
    (state) => state?.masters?.vesselMasterData
  );

  const [SendNotificationData, setSendNotificationData] = useState({
    Title: "",
    Description: "",
    VesselName: "",
  });

  const handleChangeSendNotificationData = (e) => {
    const { name, value } = e.target;
    setSendNotificationData({ ...SendNotificationData, [name]: value });
  };

  const handleSaveSendNotification = async (event) => {
    event.preventDefault();
    if (
      SendNotificationData?.Title !== "" &&
      SendNotificationData?.Description !== ""
    ) {
      if (SendNotificationData?.VesselName !== "") {
        dispatch(
          addSendNotificationMasterList({
            title: SendNotificationData?.Title,
            description: SendNotificationData?.Description,
            company_id: CompanyID,
            vessel_id: SendNotificationData?.VesselName,
            type: "HOME",
          })
        );
      } else {
        dispatch(
          addSendNotificationMasterList({
            title: SendNotificationData?.Title,
            description: SendNotificationData?.Description,
            company_id: CompanyID,
            type: "HOME",
          })
        );
      }
    } else {
      toast.error("Please enter all details to proceed");
    }
  };

  useEffect(() => {
    if (!SendNotificationModel) {
      setSendNotificationData({
        Title: "",
        Description: "",
        VesselName: "",
      });
    }
  }, [SendNotificationModel]);

  return (
    <Modal
      open={SendNotificationModel}
      onClose={() => dispatch(setIsOpenModelAddSendNotificationMaster(false))}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            marginBottom: "20px",
          }}
        >
          <Box sx={{ width: "90%" }}>
            <Typography
              align="center"
              sx={{
                color: "#212121",
                fontSize: "22px",
                fontWeight: 500,
                position: "relative",
                left: "35px",
              }}
            >
              Add Send Notification
            </Typography>
          </Box>
          <Box
            sx={{
              width: "10%",
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              mr: 3,
            }}
          >
            <ImageListItem
              sx={{ cursor: "pointer", width: "15px" }}
              onClick={() =>
                dispatch(setIsOpenModelAddSendNotificationMaster(false))
              }
            >
              <img src={Close} alt="" />
            </ImageListItem>
          </Box>
        </Box>
        <Divider />
        <Box sx={{ padding: "20px" }}>
          <Box>
            <Box sx={{ mb: "12px" }}>
              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="Title"
                type="text"
                name="Title"
                value={SendNotificationData?.Title}
                onChange={handleChangeSendNotificationData}
                sx={{
                  width: "100%",
                  borderRadius: "10px",
                  backgroundColor: "#F3F6F9",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            <Box sx={{ mb: "12px" }}>
              <TextField
                id="outlined-basic"
                multiline
                rows={3}
                variant="outlined"
                placeholder="Description"
                type="text"
                name="Description"
                value={SendNotificationData?.Description}
                onChange={handleChangeSendNotificationData}
                sx={{
                  width: "100%",
                  borderRadius: "10px",
                  backgroundColor: "#F3F6F9",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            <Box>
              <Select
                id="outlined-basic"
                variant="outlined"
                displayEmpty
                IconComponent={() => (
                  <Box
                    sx={{
                      marginRight: "10px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={GreyDownArrow}
                      alt="Custom Icon"
                      width="18"
                      height="24"
                    />
                  </Box>
                )}
                name="VesselName"
                value={SendNotificationData?.VesselName}
                onChange={handleChangeSendNotificationData}
                sx={{
                  width: "100%",
                  borderRadius: "10px",
                  backgroundColor: "#F3F6F9",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              >
                <MenuItem value="">All</MenuItem>
                {vesselMasterData.map((row) => (
                  <MenuItem value={row?.id}>{row?.name}</MenuItem>
                ))}
              </Select>
            </Box>
          </Box>
          <Box
            sx={{
              marginTop: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "15px",
            }}
          >
            <Box>
              <Button
                sx={{
                  fontSize: "15px",
                  border: "1px solid #26875C",
                  fontWeight: 600,
                  width: "8rem",
                  padding: "10px 5px 10px 5px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#26875C",
                }}
                onClick={() =>
                  dispatch(setIsOpenModelAddSendNotificationMaster(false))
                }
              >
                Cancel
              </Button>
            </Box>
            <Box>
              <LoadingButton
                onClick={handleSaveSendNotification}
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  width: "8rem",
                  border: "1px solid #26875C",
                  backgroundColor: "#26875C",
                  padding: "10px 5px 10px 5px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#FFFFFF",
                  ":hover": {
                    backgroundColor: "#26875C",
                  },
                }}
                loading={isSaveButtonLoading}
              >
                Save
              </LoadingButton>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddNotificationBroadcastModel;
